export var MAX_DEGREES = 360;
export var INNER_WIDTH = 30;
export var OUTER_WIDTH = 5;
export var ALIGN_STROKE = 1;
export var DEFAULT_MIN = 0;
export var DEFAULT_MAX = 100;
export var MAX_VALUE_PLACEHOLDER = 'Target Value';
